import { LETTERS, pad } from "../../qa";
import styles from "./AnalyticsPanel.module.css";

const SYMBOL = { correct: "✓", incorrect: "×", unverified: "–" };

export default function AnalyticsPanel({ set, statuses, distribution }) {
  const answered = set.questions.filter((q) => statuses[q.id] !== "unverified").length;
  const percent = Math.round((answered / set.questions.length) * 100);
  const peak = Math.max(...distribution, 1);

  return (
    <aside className={styles.panel} aria-label="Set analytics">
      <h2 className={styles.title}>Set Analytics</h2>

      <dl className={styles.stats}>
        <div className={styles.stat}>
          <dt>Current set</dt>
          <dd className={styles.big}>{pad(set.id)}</dd>
        </div>
        <div className={styles.stat}>
          <dt>Questions</dt>
          <dd className={styles.big}>{set.questions.length}</dd>
        </div>
        {set.questions.map((q) => (
          <div key={q.id} className={styles.stat}>
            <dt>{q.difficulty}</dt>
            <dd className={styles.big}>{SYMBOL[statuses[q.id]]}</dd>
          </div>
        ))}
      </dl>

      <div className={styles.block}>
        <div className={styles.row}>
          <label htmlFor="qa-verif" className={styles.label}>Verification</label>
          <span className={styles.percent}>{percent}%</span>
        </div>
        <progress id="qa-verif" className={styles.progress} max={100} value={percent} />
      </div>

      <div className={styles.block}>
        <p className={styles.label}>Answer distribution / all keys</p>
        <ul className={styles.bars}>
          {LETTERS.map((letter, i) => (
            <li key={letter} className={styles.bar}>
              <span className={styles.letter}>{letter}</span>
              <progress
                className={styles.progress}
                max={peak}
                value={distribution[i]}
                aria-label={`Answer ${letter}`}
              />
              <span className={styles.count}>{distribution[i]}</span>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
